// src/Pages/Admin/Event/EventList.tsx
import React from "react";
import { AdminEvent } from "./types";
import './AdminEvent.css';
interface EventListProps {
    events: AdminEvent[];
    onEdit: (eventID: number) => Promise<void> | void;
    onDelete: (eventID: number) => Promise<void> | void;
    onToggleStatus: (event: AdminEvent) => Promise<void> | void;
}

const EventList: React.FC<EventListProps> = ({ events, onEdit, onDelete, onToggleStatus }) => {
    return (
        <div className="event-table-container">
            <table className="event-table event-table-modern">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Navn</th>
                        <th>Status</th>
                        <th>Type</th>
                        <th>Handlinger</th>
                    </tr>
                </thead>
                <tbody>
                    {events.map((event) => {
                        const eventID = event.eventID;
                        return (
                            <tr key={eventID ?? Math.random()}>
                                <td className="col-id">{eventID ?? "-"}</td>
                                <td className="col-name">{event.eventName}</td>
                                <td>
                                    <button
                                        className={`status-toggle-btn ${event.active ? "active" : "inactive"}`}
                                        onClick={() => onToggleStatus(event)}
                                    >
                                        {event.active ? "Aktiv" : "Inaktiv"}
                                    </button>
                                </td>
                                <td>{event.isInternal ? "Intern" : "Ekstern"}</td>
                                <td>
                                    {eventID !== undefined && (
                                        <div className="table-buttons">
                                            <button className="edit-btn" onClick={() => onEdit(eventID)}>Rediger</button>
                                            <button className="delete-btn"
                                                onClick={() =>
                                                    window.confirm("Er du sikker på, at du vil slette dette event?") &&
                                                    onDelete(eventID)
                                                }>Slet</button>
                                        </div>
                                    )}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default EventList;